import { useNavigate } from "react-router-dom";
import Description from "../../../components/ui/Description";
import TitleStyles from "../../../components/ui/TitleStyles";
import ProgressBar from "../../../components/progressBar/ProgressBar";
import InputLinkGroup from "../../../components/inputLinkGroup/InputLinkGroup";
import ButtonGroup from "../../../components/ui/ButtonGroup";
import { Container, Group, Position } from "./SocialMediaStyles";

const SocialMedia = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <TitleStyles> Social Mídia Links</TitleStyles>
      <Description>Adicione os links das suas mídias sociais</Description>

      <Group>
        <InputLinkGroup
          nameLabel="Instagram"
          namePlaceholder="@seuusuario"
          urlLabel="Link"
          urlPlaceholder="https://www.instagram.com/seuusuario"
          allowAdd={false}
          previewEnabled={false}
          urlRequired={false}
          allowedDomains={["instagram.com"]}
          autoBuildUrl="instagram" // ⬅️ novo
          onChange={(items) => console.log("Instagram:", items)}
        />

        <InputLinkGroup
          nameLabel="Spotify"
          namePlaceholder="Nome no Spotify"
          urlLabel="Link"
          urlPlaceholder="https://open.spotify.com/artist/seu-id"
          allowAdd={false}
          previewEnabled={false}
          urlRequired={false}
          allowedDomains={["open.spotify.com", "spotify.com"]}
          onChange={(items) => console.log("Spotify:", items)}
        />

        <InputLinkGroup
          nameLabel="SoundCloud"
          namePlaceholder="soundcloud.com/seuusuario"
          urlLabel="Link"
          urlPlaceholder="https://soundcloud.com/seuusuario"
          allowAdd={false}
          previewEnabled={false}
          urlRequired={false}
          allowedDomains={["soundcloud.com"]}
          onChange={(items) => console.log("SoundCloud:", items)}
        />

        <InputLinkGroup
          nameLabel="YouTube"
          namePlaceholder="Nome do Canal"
          urlLabel="Link"
          urlPlaceholder="https://www.youtube.com/@seucanal"
          allowAdd={false}
          previewEnabled={false}
          urlRequired={false}
          allowedDomains={["youtube.com", "youtu.be"]}
          onChange={(items) => console.log("YouTube:", items)}
        />

        <InputLinkGroup
          nameLabel="WhatsApp"
          namePlaceholder="+55 41 99999-0000"
          urlLabel="Link"
          urlPlaceholder="https://wa.me/5541999990000"
          allowAdd={false}
          previewEnabled={false}
          urlRequired={false}
          allowedDomains={["wa.me", "api.whatsapp.com", "whatsapp.com"]}
          autoBuildUrl="whatsapp" // ⬅️ novo
          onChange={(items) => console.log("WhatsApp:", items)}
        />
      </Group>

      <Position>
        <ProgressBar totalSteps={9} currentStep={6} />
        <ButtonGroup
          onBack={() => navigate("/phrase")}
          onNext={() => navigate("/edit")}
        />
      </Position>
    </Container>
  );
};

export default SocialMedia;
